import http from "../utils/http";
function request(url, method = "get", data = {}, headers = {}) {
  return http({
    url,
    method,
    data,
    headers
  });
}

function post(url, data = {}, headers = {}) {
  return request(url, "post", data, headers);
}

const api = {
  imageUrl: process.env.VUE_APP_BASH_URL,
  videoUrl: process.env.VUE_APP_BASH_URL,
  formatImageUrl(url) {
    const bashImageUrl = this.imageUrl;
    return bashImageUrl + url;
  },
  formatVideoUrl(url) {
    if (!url) return null;
    const bashVideoUrl = this.videoUrl;
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      return url;
    }
    if (url.indexOf("/") === 0) {
      return bashVideoUrl + url.slice(1);
    }
    return bashVideoUrl + url;
  },
  formatVtrackUrl(url) {
    const vtrackImageUrl = "https://api.vtrack.top";
    return vtrackImageUrl + url;
  },
  myHome: {
    getUserInfo(data) {
      return post("/User/LoadUserInfo", data);
    },
    editUserInfo(data) {
      return post("/User/EditUserInfo", data);
    },
    addCompanyInfo(data) {
      return post("/User/AddCompanyInfo", data);
    },
    editCompanyInfo(data) {
      return post("/User/EditCompanyInfo", data);
    },
    userSharingQrCode(data) {
      return post("/User/UserSharingQrCodeByBase64", data);
    },
    getQrCodeByBase64(data) {
      return post("/User/GetQrCodeByBase64", data);
    },
    loadMyWorkbench(data) {
      return post("/Home/LoadMyWorkbench", data);
    },
    paymentSuccess(data) {
      return post("/User/PaymentSuccess", data);
    },
    loadCompanyOrderInfo(data) {
      return post("/User/LoadCompanyOrderInfo", data);
    },
    selectedMenuIdTotalAmount(data) {
      return post("/User/SelectedMenuIdTotalAmount", data);
    },
    getSystemPaymentCurrencyConfigList(data) {
      return post("/Home/GetSystemPaymentCurrencyConfigList", data);
    },
    getCouponAmountByCouponNumber(data) {
      return post("/User/GetCouponAmountByCouponNumber", data);
    },
    getVersionInfoByPlatform(data) {
      return post("/AdminSystem/GetVersionInfoByPlatform", data);
    },
  },
  kefu: {
    cozeChatPage(data) {
      return post("/Purchasing/cozeChatPage", data);
    },
    cozeChat(data) {
      return post("/Purchasing/CozeChat", data);
    },
  },
  print: {
    createBarCodePdf(data) {
      return post("/WayBill/CreateBarCodePdf", data);
    },
    createCargoTransportationAccountPdf(data) {
      return post("/WayBill/CreateCargoTransportationAccountPdf", data);
    },
    createEntrustOrderFile(data) {
      return post("/SalesManagent/CreateEntrustOrderFile", data);
    },
    getTransportContractContent(data) {
      return post("/System/GetTransportContractContent", data);
    },
    createQuotationInfoPdf(data) {
      return post("/SalesManagent/CreateQuotationInfoPdf", data);
    },
    createPriceListPdf(data) {
      return post("/WayBill/CreatePriceListPdf", data);
    },
    createPackingListPdf(data) {
      return post("/WayBill/CreatePackingListPdf", data);
    },
    createWarehousingNoticeFile(data) {
      return post("/EntrustOrder/CreateWarehousingNoticeFile", data);
    },
    createPreAlertFile(data) {
      return post("/WayBill/CreatePreAlertFile", data);
    },
    createWarehouseOutboundWorkOrderFile(data) {
      return post("/Storage/CreateWarehouseOutboundWorkOrderFile", data);
    },
    createWarehouseProfitAccountingFile(data) {
      return post("/Storage/CreateWarehouseProfitAccountingFile", data);
    },
    createSOPCargoArrangementFile(data) {
      return post("/SalesManagent/CreateSOPCargoArrangementFile", data);
    },
    createBusinessPaymentRequestDetailFile(data) {
      return post("/FinancialBills/CreateBusinessPaymentRequestDetailFile", data);
    },
    createArrivalNoticeFile(data) {
      return post("/WayBill/CreateArrivalNoticeFile", data);
    },
    createCollectionBillPdf(data) {
      return post("/WayBill/CreateCollectionBillPdf", data);
    },
    createProcurementProductListFile(data) {
      return post("/Procurement/CreateProcurementProductListFile", data);
    },
    createSalesTradeOrderFile(data) {
      return post("/Procurement/CreateSalesTradeOrderFile", data);
    }
  },
  logisticsManagement: {
    getWayBillList(data) {
      return post("/WayBill/WayBillListByPage", data);
    },
    getLogisticsStateList(data) {
      return post("/WayBill/LogisticsStateListByPage", data);
    },
    editWayBillLogisticsStatus(data) {
      return post("/WayBill/EditWayBillLogisticsStatus", data);
    },
    addWayBillByPrimary(data) {
      return post("/WayBill/AddWayBillByPrimary", data);
    },
    editWayBillByPrimary(data) {
      return post("/WayBill/EditWayBillByPrimary", data);
    },
    deleteWayBillInfo(data) {
      return post("/WayBill/DeleteWayBillInfo", data);
    },
    getWayBillByPrimaryFileList(data) {
      return post("/WayBill/GetWayBillByPrimaryFileList", data);
    },
    loadWayBillInfo(data) {
      return post("/WayBill/LoadWayBillInfo", data);
    },
    addCollectionBill(data) {
      return post("/WayBill/AddCollectionBill", data);
    },
    editCollectionBill(data) {
      return post("/WayBill/EditCollectionBill", data);
    },
    addSupplierCostDetails(data) {
      return post("/WayBill/AddSupplierCostDetails", data);
    },
    editSupplierCostDetails(data) {
      return post("/WayBill/EditSupplierCostDetails", data);
    },
    getCountryList(data) {
      return post("/WayBill/GetCountryList", data);
    },
    waybillGoodsWarehousing(data) {
      return post("/WayBill/WaybillGoodsWarehousing", data);
    },
    getWayBillShippingLabelPrintInfoByWB_Number(data) {
      return post("/WayBill/GetWayBillShippingLabelPrintInfoByWB_Number", data);
    },
    addLogisticsState(data) {
      return post("/WayBill/AddLogisticsState", data);
    },
    editLogisticsState(data) {
      return post("/WayBill/EditLogisticsState", data);
    },
    deleteLogisticsState(data) {
      return post("/WayBill/DeleteLogisticsState", data);
    },
    getCargoTransportationAccount(data) {
      return post("/WayBill/GetCargoTransportationAccount", data);
    },
    deleteSupplierCostDetails(data) {
      return post("/WayBill/DeleteSupplierCostDetails", data);
    },
    deleteCollectionBill(data) {
      return post("/WayBill/DeleteCollectionBill", data);
    },
    getOrderReceivingCenterList(data) {
      return post("/WayBill/GetOrderReceivingCenterList", data);
    },
    getCargoFileCentersList(data) {
      return post("/WayBill/GetCargoFileCentersList", data);
    },
    getCargoTransportFileDetail(data) {
      return post("/WayBill/GetCargoTransportFileDetail", data);
    },
    getEntrustOrderSupplierFileList(data) {
      return post("/EntrustOrder/GetEntrustOrderSupplierFileList", data);
    },
    addEntrustOrderSupplierFile(data) {
      return post("/EntrustOrder/AddEntrustOrderSupplierFile", data)
    },
    addEntrustOrderSupplier(data) {
      return post("/EntrustOrder/AddEntrustOrderSupplier", data)
    },
    deleteEntrustOrderSupplier(data) {
      return post("/EntrustOrder/DeleteEntrustOrderSupplier", data)
    },
    updateSupplierEmailInfo(data) {
      return post("/FinancialBills/UpdateSupplierEmailInfo", data)
    },
    entrustOrderInvitationEmail(data) {
      return post("/EntrustOrder/EntrustOrderInvitationEmail", data)
    },
    saveCargoFile(data) {
      return post("/WayBill/SaveCargoFile", data);
    },
    getPreAlertList(data) {
      return post("/WayBill/GetPreAlertList", data);
    },
    getPreAlertInfo(data) {
      return post("/WayBill/GetPreAlertInfo", data);
    },
    getPreAlterOperationLogList(data) {
      return post("/WayBill/GetPreAlterOperationLogList", data);
    },
    loadPreAlertInfo(data) {
      return post("/WayBill/LoadPreAlertInfo", data);
    },
    getArrivalNoticeDetail(data) {
      return post("/WayBill/GetArrivalNoticeDetail", data);
    },
    editPreAlertInfo(data) {
      return post("/WayBill/EditPreAlertInfo", data);
    },
    savePreAlertInfo(data) {
      return post("/WayBill/SavePreAlertInfo", data);
    },
    vtrackInternaPush(data) {
      return post("/WayBill/VtrackInternaPush", data);
    },
    sendFileDetailsEmail(data) {
      return post("/WayBill/SendFileDetailsEmail", data);
    },
    sendMailByPreAlertFile(data) {
      return post("/WayBill/SendMailByPreAlertFile", data);
    },
    createWorkOrderByPreAlert(data) {
      return post("/WayBill/CreateWorkOrderByPreAlert", data);
    },
    editPreAlertState(data) {
      return post("/WayBill/EditPreAlertState", data);
    },
    getWayBillOperationLog(data) {
      return post("/WayBill/GetWayBillOperationLog", data);
    },
    addAirWayBill(data) {
      return post("/WayBill/AddWayBillAirTransport", data);
    },
    addWayBillShippingByNew(data) {
      return post("/WayBill/AddWayBillShippingByNew", data);
    },
    addWayBill(data) {
      return post("/WayBill/AddWayBill", data);
    },
    getWayBillCabinetTypeListByClassId(data) {
      return post("/WayBill/GetWayBillCabinetTypeListByClassId", data);
    },
    getWayBillAddressHistoryList(data) {
      return post("/WayBill/GetWayBillAddressHistoryList", data);
    },
    getCollectionBillSharingEmail(data) {
      return post("/WayBill/GetCollectionBillSharingEmail", data);
    },
    getUserInvoiceShareEmailHistoryList(data) {
      return post("/FinancialBills/GetUserInvoiceShareEmailHistoryList", data);
    },
    addExpressCargoWarehousing(data) {
      return post("/WayBill/AddExpressCargoWarehousing", data);
    },
    loadWaybillByCOIdList(data) {
      return post("/WayBill/LoadWaybillByCOIdList", data);
    },
    getWayBillDetail(data) {
      return post("/WayBill/WayBillDetail", data);
    },
    getCustomsCodeHistoryListByGoodsDescribe(data) {
      return post("/WayBill/GetCustomsCodeHistoryListByGoodsDescribe", data);
    },
    getConditionsQueryHsCode(data) {
      return post("/WayBill/GetConditionsQueryHsCode", data);
    }
  },
  platformOrders: {
    getHualeiOrderList(data) {
      return post("/WayBill/GetHualeiOrderList", data);
    },
    getTemuManifestList(data) {
      return post("/WayBill/GetTemuManifestList", data);
    },
    getHualeiOrderByHOId(data) {
      return post("/WayBill/GetHualeiOrderByHOId", data);
    }
  },
  storage: {
    editExpressCargoWarehousing(data) {
      return post("/Storage/EditExpressCargoWarehousing", data);
    },
    getExpressCargoWarehousingInfoByECWId(data) {
      return post("/Storage/GetExpressCargoWarehousingInfoByECWId", data);
    },
    editOutboundBatch(data) {
      return post("/Storage/EditOutboundBatch", data);
    },
    getOutboundDetailByOutboundBatch(data) {
      return post("/Storage/GetOutboundDetailByOutboundBatch", data);
    },
    applyOutbound(data) {
      return post("/Storage/ApplyOutbound", data);
    },
    getCargoWarehousingListByPage(data) {
      return post("/Storage/GetCargoWarehousingListByPage", data);
    },
    getCargoOutboundListByPage(data) {
      return post("/Storage/GetCargoOutboundListByPage", data);
    },
    getExpressCargoWaybillInfoByECWBId(data) {
      return post("/Storage/GetExpressCargoWaybillInfoByECWBId", data);
    },
    updateExpressEmployeeStateByEMId(data) {
      return post("/Storage/UpdateExpressEmployeeStateByEMId", data);
    },
    getExpressEmployeeInfo(data) {
      return post("/Storage/GetExpressEmployeeInfo", data);
    },
    addExpressEmployeeInfo(data) {
      return post("/Storage/AddExpressEmployeeInfo", data);
    },
    editExpressEmployeeInfo(data) {
      return post("/Storage/EditExpressEmployeeInfo", data);
    },
    deleteExpressEmployeeInfo(data) {
      return post("/Storage/DeleteExpressEmployeeInfo", data);
    },
    addVehicles(data) {
      return post("/Storage/AddVehicles", data);
    },
    deleteVehicles(data) {
      return post("/Storage/DeleteVehicles", data);
    },
    editVehicles(data) {
      return post("/Storage/EditVehicles", data);
    },
    getVehiclesInfo(data) {
      return post("/Storage/GetVehiclesInfo", data);
    },
    batchUpdateVehicleStatusById(data) {
      return post("/Storage/BatchUpdateVehicleStatusById", data);
    },
    getVehiclesListByPage(data) {
      return post("/Storage/GetVehiclesListByPage", data);
    },
    getWarehouseManagementList(data) {
      return post("/Storage/GetWarehouseManagementList", data);
    },
    editWarehouseManagementState(data) {
      return post("/Storage/EditWarehouseManagementState", data);
    },
    getWarehouseManagementDetail(data) {
      return post("/Storage/GetWarehouseManagementDetail", data);
    },
    addWarehouseManagement(data) {
      return post("/Storage/AddWarehouseManagement", data)
    },
    editWarehouseManagement(data) {
      return post("/Storage/EditWarehouseManagement", data)
    },
    deleteWarehouseManagement(data) {
      return post("/Storage/DeleteWarehouseManagement", data)
    },
    getWarehouseTypeList(data) {
      return post("/Storage/GetWarehouseTypeList", data)
    },
    getWarehouseFormSettingList(data) {
      return post("/Storage/GetWarehouseFormSettingList", data)
    },
    editWarehouseFormState(data) {
      return post("/Storage/EditWarehouseFormState", data)
    },
    getWarehouseFormSettingDetail(data) {
      return post("/Storage/GetWarehouseFormSettingDetail", data)
    },
    addWarehouseFormSetting(data) {
      return post("/Storage/AddWarehouseFormSetting", data)
    },
    editWarehouseFormSetting(data) {
      return post("/Storage/EditWarehouseFormSetting", data)
    },
    getPendingWarehousingList(data) {
      return post("/Storage/GetPendingWarehousingList", data)
    },
    getAlreadyWarehousingList(data) {
      return post("/Storage/GetAlreadyWarehousingList", data)
    },
    getCargoOperationLogList(data) {
      return post("/Storage/GetCargoOperationLogList", data)
    },
    getOutboundList(data) {
      return post("/Storage/GetOutboundList", data)
    },
    editWarehousingApplyForExpressInfo(data) {
      return post("/Storage/EditWarehousingApplyForExpressInfo", data)
    },
    editWarehousingApplyForDeliveryInfo(data) {
      return post("/Storage/EditWarehousingApplyForDeliveryInfo", data)
    },
    addWarehousingGood(data) {
      return post("/Storage/AddWarehousingGood", data)
    },
    getCustomerAndWarehouseByCustomerNumber(data) {
      return post("/Storage/GetCustomerAndWarehouseByCustomerNumber", data)
    },
    addWarehousingWorkSheet(data) {
      return post("/Storage/AddWarehousingWorkSheet", data)
    },
    editWarehousingWorkSheet(data) {
      return post("/Storage/EditWarehousingWorkSheet", data)
    },
    getWarehousingApplyForDetail(data) {
      return post("/Storage/GetWarehousingApplyForDetail", data)
    },
    getWarehouseWorkOrderDetail(data) {
      return post("/Storage/GetWarehouseWorkOrderDetail", data)
    },
    addWarehouseOutbound(data) {
      return post("/Storage/AddWarehouseOutbound", data)
    },
    getWarehouseOutboundWorkOrderDetail(data) {
      return post("/Storage/GetWarehouseOutboundWorkOrderDetail", data)
    },
    editWorkOrderProductName(data) {
      return post("/Storage/EditWorkOrderProductName", data)
    },
    editProductPicturesByPId(data) {
      return post("/Storage/EditProductPicturesByPId", data)
    },
    getWarehouseProfitAccounting(data) {
      return post("/Storage/GetWarehouseProfitAccounting", data);
    },
    loadWarehousingWorkSheetByPreAlertInfo(data) {
      return post("/Storage/LoadWarehousingWorkSheetByPreAlertInfo", data);
    },
    getExpressEmployeeListByPage(data) {
      return post("/Storage/GetExpressEmployeeListByPage", data);
    },
    getExceptionCargoListByPage(data) {
      return post("/Storage/GetExceptionCargoListByPage", data);
    },
    getWaybillExceptionHandlingRecordListByPage(data) {
      return post("/Storage/GetWaybillExceptionHandlingRecordListByPage", data);
    },
    saveCargoExceptionHandlingByWB_Id(data) {
      return post("/Storage/SaveCargoExceptionHandlingByWB_Id", data);
    },
    getOrderDeliveryExceptionHandlingByWB_Id(data) {
      return post("/Purchasing/GetOrderDeliveryExceptionHandlingByWB_Id", data);
    },
    getCustomerReceivingList(data) {
      return post("/Purchasing/GetCustomerReceivingList", data);
    },
    editCustomerReceiving(data) {
      return post("/Purchasing/EditCustomerReceiving", data);
    }
  },
  marketRisk: {
    getAdvertList(data) {
      return post("/System/GetAdvertList", data);
    },
    addAdvert(data) {
      return post("/System/AddAdvert", data);
    },
    editAdvert(data) {
      return post("/System/EditAdvert", data);
    },
    editAdvertIsShow(data) {
      return post("/System/EditAdvertIsShow", data);
    },
    getCustomerRestrictedList(data) {
      return post("/MarketRisk/GetCustomerRestrictedList", data);
    },
    editCustomerRestrictedIsRemove(data) {
      return post("/MarketRisk/EditCustomerRestrictedIsRemove", data);
    },
    addCustomerRestricted(data) {
      return post("/MarketRisk/AddCustomerRestricted", data);
    },
    getEmailConfigList(data) {
      return post("/MarketRisk/GetEmailConfigList", data);
    },
    updateEmailConfigEnabled(data) {
      return post("/MarketRisk/UpdateEmailConfigEnabled", data);
    },
    addEmailConfig(data) {
      return post("/MarketRisk/AddEmailConfig", data);
    },
    getAntiMoneyLaunderingListQuery(data) {
      return post("/System/GetAntiMoneyLaunderingListQuery", data);
    },
    getAntiMoneyLaunderingRecordsByKeyword(data) {
      return post("/System/GetAntiMoneyLaunderingRecordsByKeyword", data);
    },
    getAntiMoneyLaunderingListQueryRecordByPage(data) {
      return post("/System/GetAntiMoneyLaunderingListQueryRecordByPage", data);
    },
    getAntiMoneyLaunderingScanListDetail(data) {
      return post("/System/GetAntiMoneyLaunderingScanListDetail", data);
    },
    getAntiMoneyLaunderingListQueryResult(data) {
      return post("/System/GetAntiMoneyLaunderingListQueryResult", data);
    }
  },
  salesManagement: {
    getUnquoteList(data) {
      return post("/SalesManagent/GetUnquoteList", data);
    },
    getQuotationChargesList(data) {
      return post("/SalesManagent/GetQuotationChargesList", data);
    },
    getQuotationReferenceInfo(data) {
      return post("/SalesManagent/GetQuotationReferenceInfo", data);
    },
    getEntrustOrderSetting(data) {
      return post("/EntrustOrder/GetEntrustOrderSetting", data);
    },
    loadQuotationInfo(data) {
      return post("/SalesManagent/LoadQuotationInfo", data);
    },
    addQuotationCharges(data) {
      return post("/SalesManagent/AddQuotationCharges", data);
    },
    editQuotationCharges(data) {
      return post("/SalesManagent/EditQuotationCharges", data);
    },
    getOrderProcessingCenterList(data) {
      return post("/SalesManagent/GetOrderProcessingCenterList", data);
    },
    getEntrustOrderInfo(data) {
      return post("/SalesManagent/GetEntrustOrderInfo", data);
    },
    loadSOPCargoArrangement(data) {
      return post("/SalesManagent/LoadSOPCargoArrangement", data);
    },
    addSOPCargoArrangement(data) {
      return post("/SalesManagent/AddSOPCargoArrangement", data);
    },
    editSOPCargoArrangement(data) {
      return post("/SalesManagent/EditSOPCargoArrangement", data);
    },
    deleteEntrustOrder(data) {
      return post("/SalesManagent/DeleteEntrustOrder", data);
    },
    getReceivablePaymentList(data) {
      return post("/FinancialBills/GetReceivablePaymentList", data);
    },
    getNuclearAccountRecordsList(data) {
      return post("/FinancialBills/GetNuclearAccountRecordsList", data);
    },
    getProfitStatisticsList(data) {
      return post("/FinancialBills/GetProfitStatisticsList", data);
    }
  },
  financialManagement: {
    getSystemAvailableCurrencyList(data) {
      return post("/FinancialBills/GetSystemAvailableCurrencyList", data);
    },
    getBillPaymentList(data) {
      return post("/FinancialBills/GetBillPaymentList", data);
    },
    getBillPaymentListByCompanyId(data) {
      return post("/FinancialBills/GetBillPaymentListByCompanyId", data);
    },
    getCollectionAccountInfoList(data) {
      return post("/FinancialBills/GetCollectionAccountInfoList", data);
    },
    getSupplierCostDetails(data) {
      return post("/FinancialBills/SupplierCostDetails", data);
    },
    getCollectionBillDetails(data) {
      return post("/FinancialBills/CollectionBillDetails", data);
    },
    editAccountIsEnable(data) {
      return post("/FinancialBills/EditAccountIsEnable", data);
    },
    getCollectionAccountDetail(data) {
      return post("/FinancialBills/GetCollectionAccountDetail", data);
    },
    addCollectionAccountInfo(data) {
      return post("/FinancialBills/AddCollectionAccountInfo", data);
    },
    editCollectionAccountInfo(data) {
      return post("/FinancialBills/EditCollectionAccountInfo", data);
    },
    deleteCollectionAccountInfo(data) {
      return post("/FinancialBills/DeleteCollectionAccountInfo", data);
    },
    addBillPayment(data) {
      return post("/FinancialBills/AddBillPayment", data);
    },
    editBillPayment(data) {
      return post("/FinancialBills/EditBillPayment", data);
    },
    deleteBillPayment(data) {
      return post("/FinancialBills/DeleteBillPayment", data);
    },
    getExchangeRateList(data) {
      return post("/FinancialBills/GetExchangeRateList", data);
    },
    addExchangeRate(data) {
      return post("/FinancialBills/AddExchangeRate", data);
    },
    getExchangeRateLogList(data) {
      return post("/FinancialBills/GetExchangeRateLogList", data);
    },
    getInvoiceItemList(data) {
      return post("/FinancialBills/GetInvoiceItemList", data);
    },
    getInvoiceItemListByCompanyId(data) {
      return post("/FinancialBills/GetInvoiceItemListByCompanyId", data);
    },
    getInvoiceItemDetail(data) {
      return post("/FinancialBills/GetInvoiceItemDetail", data);
    },
    addInvoiceItem(data) {
      return post("/FinancialBills/AddInvoiceItem", data);
    },
    editInvoiceItem(data) {
      return post("/FinancialBills/EditInvoiceItem", data);
    },
    deleteInvoiceItem(data) {
      return post("/FinancialBills/DeleteInvoiceItem", data);
    },
    getReceivablePaymentList(data) {
      return post("/FinancialBills/GetReceivablePaymentList", data);
    },
    getPayablePaymentList(data) {
      return post("/FinancialBills/GetPayablePaymentList", data);
    },
    getInvoiceFileListByInvoiceNo(data) {
      return post("/FinancialBills/GetInvoiceFileListByInvoiceNo", data);
    },
    getInvoiceFileList(data) {
      return post("/FinancialBills/GetInvoiceFileList", data);
    },
    getProfitStatisticsList(data) {
      return post("/FinancialBills/GetProfitStatisticsList", data);
    },
    getNuclearAccountRecordsList(data) {
      return post("/FinancialBills/GetNuclearAccountRecordsList", data);
    },
    getCreditedDetailList(data) {
      return post("/FinancialBills/GetCreditedDetailList", data);
    },
    getAvailableInvoiceList(data) {
      return post("/FinancialBills/GetAvailableInvoiceList", data);
    },
    getTaxInvoiceList(data) {
      return post("/FinancialBills/GetTaxInvoiceList", data);
    },
    addTaxInvoice(data) {
      return post("/FinancialBills/AddTaxInvoice", data);
    },
    hadAppliedInvoicedRefund(data) {
      return post("/FinancialBills/HadAppliedInvoicedRefund", data);
    },
    invoicedRefund(data) {
      return post("/FinancialBills/InvoicedRefund", data);
    },
    getBankAccountInfoByBankId(data) {
      return post("/Customer/GetBankAccountInfoByBankId", data);
    },
    addInvoiceFile(data) {
      return post("/FinancialBills/AddInvoiceFile", data);
    },
    getTaxInvoiceSharingEmail(data) {
      return post("/FinancialBills/GetTaxInvoiceSharingEmail", data);
    },
    getFinancialRequestList(data) {
      return post("/FinancialBills/GetFinancialRequestList", data);
    },
    getNuclearAccountPaymentVoucherList(data) {
      return post("/FinancialBills/GetNuclearAccountPaymentVoucherList", data);
    },
    getOperatingExpenseVoucherList(data) {
      return post("/FinancialBills/GetOperatingExpenseVoucherList", data);
    },
    getFinancialAuditList(data) {
      return post("/FinancialBills/GetFinancialAuditList", data);
    },
    getReceivedSupplierPaymentInvoiceList(data) {
      return post("/FinancialBills/GetReceivedSupplierPaymentInvoiceList", data);
    },
    createPaymentInvoiceByReceivedInvoice(data) {
      return post("/FinancialBills/CreatePaymentInvoiceByReceivedInvoice", data);
    },
    loadPayrollRequestApplicationInfo(data) {
      return post("/FinancialBills/LoadPayrollRequestApplicationInfo", data);
    },
    editPayrollRequestApplication(data) {
      return post("/FinancialBills/EditPayrollRequestApplication", data);
    },
    addPayrollRequestApplication(data) {
      return post("/FinancialBills/AddPayrollRequestApplication", data);
    },
    cancelPayrollRequestApplication(data) {
      return post("/FinancialBills/CancelPayrollRequestApplication", data);
    },
    getBusinessPaymentRequestDetail(data) {
      return post("/FinancialBills/GetBusinessPaymentRequestDetail", data);
    },
    addPayrollRequestApprovalProcess(data) {
      return post("/FinancialBills/AddPayrollRequestApprovalProcess", data);
    },
    getFinancialAuditList(data) {
      return post("/FinancialBills/GetFinancialAuditList", data);
    },
    getFinancialRequestList(data) {
      return post("/FinancialBills/GetFinancialRequestList", data);
    },
    loadOperatingExpenseRequestInfo(data) {
      return post("/FinancialBills/LoadOperatingExpenseRequestInfo", data);
    },
    getOperatingExpenseRequestDetail(data) {
      return post("/FinancialBills/GetOperatingExpenseRequestDetail", data);
    },
    addPayrollRequestApprovalProcessByOERId(data) {
      return post("/FinancialBills/AddPayrollRequestApprovalProcessByOERId", data);
    },
    cancelOperatingExpenseRequest(data) {
      return post("/FinancialBills/CancelOperatingExpenseRequest", data);
    },
    addOperatingExpenseRequest(data) {
      return post("/FinancialBills/AddOperatingExpenseRequest", data);
    },
    editOperatingExpenseRequest(data) {
      return post("/FinancialBills/EditOperatingExpenseRequest", data);
    },
    saveOperatingExpenseVoucher(data) {
      return post("/FinancialBills/SaveOperatingExpenseVoucher", data);
    },
    getCustomerCapitalTransferList(data) {
      return post("/FinancialBills/GetCustomerCapitalTransferList", data);
    },
    getCustomerCapitalTransferDetailByCTId(data) {
      return post("/FinancialBills/GetCustomerCapitalTransferDetailByCTId", data);
    },
    getCustomerCapitalEntryFileListByCEId(data) {
      return post("/FinancialBills/GetCustomerCapitalEntryFileListByCEId", data);
    },
    getCustomerReceivedAmountAndCreditBalanceByCreateDate(data) {
      return post("/FinancialBills/GetCustomerReceivedAmountAndCreditBalanceByCreateDate", data);
    },
    getCustomerFundUseDetailList(data) {
      return post("/FinancialBills/GetCustomerFundUseDetailList", data);
    },
    getCustomerAvailableFundListByCustomerId(data) {
      return post("/FinancialBills/GetCustomerAvailableFundListByCustomerId", data);
    },
    getCustomerFundExchangeRecordByCFEId(data) {
      return post("/FinancialBills/GetCustomerFundExchangeRecordByCFEId", data);
    },
    getCustomerReceivedAmountDetailByCustomerIdAndDate(data) {
      return post("/FinancialBills/GetCustomerReceivedAmountDetailByCustomerIdAndDate", data);
    },
    getCustomerCapitalBusinessEntryList(data) {
      return post("/FinancialBills/GetCustomerCapitalBusinessEntryList", data);
    },
    getCustomerCapitalEntryByCEId(data) {
      return post("/FinancialBills/GetCustomerCapitalEntryByCEId", data);
    },
    addCustomerCapitalBusinessEntry(data) {
      return post("/FinancialBills/AddCustomerCapitalBusinessEntry", data);
    },
    editCustomerCapitalBusinessEntry(data) {
      return post("/FinancialBills/EditCustomerCapitalBusinessEntry", data);
    },
    deleteCustomerCapitalEntry(data) {
      return post("/FinancialBills/DeleteCustomerCapitalEntry", data);
    },
    getCustomerCapitalFinanceEntryList(data) {
      return post("/FinancialBills/GetCustomerCapitalFinanceEntryList", data);
    },
    addCustomerCapitalFinanceEntry(data) {
      return post("/FinancialBills/AddCustomerCapitalFinanceEntry", data);
    },
    editCustomerCapitalFinanceEntry(data) {
      return post("/FinancialBills/EditCustomerCapitalFinanceEntry", data);
    },
    loadCustomerCapitalTransferInfo(data) {
      return post("/FinancialBills/LoadCustomerCapitalTransferInfo", data);
    },
    addCustomerCapitalTransfer(data) {
      return post("/FinancialBills/AddCustomerCapitalTransfer", data);
    },
    addCustomerFundExchangeRecord(data) {
      return post("/FinancialBills/AddCustomerFundExchangeRecord", data);
    },
    customerFundWriteOff(data) {
      return post("/FinancialBills/CustomerFundWriteOff", data);
    },
    getPayrollRequestApplicationByCostId(data) {
      return post("/FinancialBills/GetPayrollRequestApplicationByCostId", data);
    }
  },
  dataSummary: {
    cargoStatistics(data) {
      return post("/DataCount/CargoStatistics", data);
    },
    getStatisticalDetailsList(data) {
      return post("/DataCount/GetStatisticalDetailsList", data);
    },
    cargoDistributionStatistics(data) {
      return post("/DataCount/CargoDistributionStatistics", data);
    },
    costCategoryStatistics(data) {
      return post("/DataCount/CostCategoryStatistics", data);
    },
    getCostCategoryDetailList(data) {
      return post("/DataCount/GetCostCategoryDetailList", data);
    },
    costCategoryRequestFundsDetailList(data) {
      return post("/DataCount/CostCategoryRequestFundsDetailList", data);
    },
    getCustomerPaymentDataByCreateDate(data) {
      return post("/DataCount/GetCustomerPaymentDataByCreateDate", data);
    },
    getCustomerPaymentDetailByCustomerIdAndDate(data) {
      return post("/DataCount/GetCustomerPaymentDetailByCustomerIdAndDate", data);
    },
    getCustomerReceivableDetailByCustomerIdAndDate(data) {
      return post("/DataCount/GetCustomerReceivableDetailByCustomerIdAndDate", data);
    },
    getCustomerReceivableDataByCreateDate(data) {
      return post("/DataCount/GetCustomerReceivableDataByCreateDate", data);
    },
    seaTransportationMonthBillStatistics(data) {
      return post("/DataCount/SeaTransportationMonthBillStatistics", data);
    },
    getCargoPortInquiryList(data) {
      return post("/DataCount/GetCargoPortInquiryList", data);
    },
    getExportGoodsStatistics(data) {
      return post("/DataCount/GetExportGoodsStatistics", data);
    },
    getExportGoodsDetail(data) {
      return post("/DataCount/GetExportGoodsDetail", data);
    }
  },
  customerManagement: {
    getCustomerInfo(data) {
      return post("/Customer/GetCustomerInfo", data);
    },
    getCustomerContactListById(data) {
      return post("/Customer/GetCustomerContactListById", data);
    },
    getCountryList(data) {
      return post("/Customer/GetCountryList", data);
    },
    getCustomerInfoSearchList(data) {
      return post("/Customer/GetCustomerInfoSearchList", data);
    },
    getCustomerInfoList(data) {
      return post("/Customer/GetCustomerInfoList", data);
    },
    getCustomerDetail(data) {
      return post("/Customer/GetCustomerDetail", data);
    },
    addCustomerInfo(data) {
      return post("/Customer/AddCustomerInfo", data);
    },
    editCustomerInfo(data) {
      return post("/Customer/EditCustomerInfo", data);
    },
    editCustomerInfoStatue(data) {
      return post("/Customer/EditCustomerInfoStatue", data);
    },
    getOverseasAgentList(data) {
      return post("/Customer/GetOverseasAgentList", data);
    },
    addOverseasAgentInfo(data) {
      return post("/Customer/AddOverseasAgentInfo", data);
    },
    getOverseasAgentInfo(data) {
      return post("/Customer/GetOverseasAgentInfo", data);
    },
    getBankAccountInfoList(data) {
      return post("/Customer/GetBankAccountInfoList", data);
    },
    updateBankAccountEffect(data) {
      return post("/Customer/UpdateBankAccountEffect", data);
    },
    addBankAccountInfo(data) {
      return post("/Customer/AddBankAccountInfo", data);
    },
    editBankAccountInfo(data) {
      return post("/Customer/EditBankAccountInfo", data);
    },
    getCustomerContactList(data) {
      return post("/Customer/GetCustomerContactList", data);
    },
    addCustomerContact(data) {
      return post("/Customer/AddCustomerContact", data);
    },
    editCustomerContact(data) {
      return post("/Customer/EditCustomerContact", data);
    },
    deleteCustomerContact(data) {
      return post("/Customer/DeleteCustomerContact", data);
    },
    getContractManagementList(data) {
      return post("/Customer/GetContractManagementList", data);
    },
    addContractManagement(data) {
      return post("/Customer/AddContractManagement", data);
    },
    editContractManagement(data) {
      return post("/Customer/EditContractManagement", data);
    },
    deleteContractManagement(data) {
      return post("/Customer/DeleteContractManagement", data);
    },
    loadCustomerHomeInfo(data) {
      return post("/Customer/LoadCustomerHomeInfo", data);
    },
    customerInfoModifyCompanyInfo(data) {
      return post("/Customer/CustomerInfoModifyCompanyInfo", data);
    },
  },
  user: {
    userLogin(data) {
      return post("/Login/UserSystemLogin", data);
    },
    userLogout(data) {
      return post("/User/UserLogout", data);
    },
    getMenuInfoList(data) {
      return post("/Home/GetMenuInfoList", data);
    },
    sendVerificationCode(data) {
      return post("/Home/SendSMS", data);
    },
    userRegister(data) {
      return post("/Login/UserSystemRegister", data);
    },
    checkAuthCode(data) {
      return post("/User/UserSMSVerification", data);
    },
    changeUserPassword(data) {
      return post("/User/PasswordReset", data);
    },
    addCompanyOrder(data) {
      return post("/User/AddCompanyOrder", data);
    },
    editElectronicWalletInfo(data) {
      return post("/User/EditElectronicWalletInfo", data);
    },
    supplierBusinessSharingQrCodeByBase64(data) {
      return post("/User/SupplierBusinessSharingQrCodeByBase64", data);
    },
    editUserShareMessage(data) {
      return post("/User/EditUserShareMessage", data);
    },
    getUserListByCompanyCode(data) {
      return post("/User/GetUserListByCompanyCode", data);
    },
    generatePaymentLink(data) {
      return post("/User/GeneratePaymentLink", data);
    },
    loadCurrentUnpaidOrder(data) {
      return post("/User/LoadCurrentUnpaidOrder", data);
    },
    loginByCustomer(data) {
      return post("/User/WeChatUsersLogin", data);
    },
  },
  systemManagement: {
    getRolesRight(data) {
      return post("/System/GetMenuPermissionList", data);
    },
    setRolesRight(data) {
      return post("/System/EditMenuPermission", data);
    },
    getRoleList(data) {
      return post("/System/RoleList", data);
    },
    addRoles(data) {
      return post("/System/AddRole", data);
    },
    editRoles(data) {
      return post("/System/EditRole", data);
    },
    deleteRoles(data) {
      return post("/System/DeleteRole", data);
    },
    editUserRole(data) {
      return post("/User/EditUserRole", data);
    },
    getUserList(data) {
      return post("/User/GetUserInfoList", data);
    },
    getUserDetail(data) {
      return post("/User/GetUserInfo", data);
    },
    editUserState(data) {
      return post("/User/EditUserState", data);
    },
    deleteUser(data) {
      return post("/User/DeleteUser", data);
    },
    setParentRight(data) {
      return post("/User/DistributionParentUser", data);
    },
    getUserListByCondition(data) {
      return post("/User/GetUserListByCondition", data);
    },
    getExpenseCategoryList(data) {
      return post("/System/GetExpenseCategoryList", data);
    },
    editSystemCurrencySettings(data) {
      return post("/FinancialBills/EditSystemCurrencySettings", data);
    },
    addSystemCurrencySettings(data) {
      return post("/FinancialBills/AddSystemCurrencySettings", data);
    },
    getSystemCurrencySettingsList(data) {
      return post("/FinancialBills/GetSystemCurrencySettingsList", data);
    },
    deleteSystemCurrencySettings(data) {
      return post("/FinancialBills/DeleteSystemCurrencySettings", data);
    },
    editSystemCurrencyUseState(data) {
      return post("/FinancialBills/EditSystemCurrencyUseState", data);
    },
    setSettlementCurrency(data) {
      return post("/FinancialBills/SetSettlementCurrency", data);
    },
    loadCompanyInvoiceTitleInfo(data) {
      return post("/User/LoadCompanyInvoiceTitleInfo", data);
    },
    addCompanyInvoiceTitle(data) {
      return post("/User/AddCompanyInvoiceTitle", data);
    },
    getCompanyOrderList(data) {
      return post("/User/GetCompanyOrderList", data);
    },
    getFinancialAuditProcessSettingsList(data) {
      return post("/System/GetFinancialAuditProcessSettingsList", data);
    },
    addFinancialAuditProcessSettings(data) {
      return post("/System/AddFinancialAuditProcessSettings", data);
    },
    getExpenseCategoryList(data) {
      return post("/System/GetExpenseCategoryList", data);
    },
    addExpenseCategory(data) {
      return post("/System/AddExpenseCategory", data);
    },
    editExpenseCategory(data) {
      return post("/System/EditExpenseCategory", data);
    },
    deleteExpenseCategory(data) {
      return post("/System/DeleteExpenseCategory", data);
    }
  },
  system: {
    uploadImgFile: data => {
      return post("/Home/UniversalUploadPic", data);
    },
    UploadPdfFile: data => {
      return post("/Customer/UploadPdfFile", data);
    },
    tokenRefresh: data => {
      return post("/Login/TokenRefresh", data, { 'Token-Refresh': true });
    }
  },
  myCustomer: {
    addEntrustOrder(data) {
      return post("/EntrustOrder/AddEntrustOrder", data);
    },
    getTakeDeliveryCountryCityList(data) {
      return post("/EntrustOrder/GetTakeDeliveryCountryCityList", data);
    },
    getCustomerSupplierQuotationListByPage(data) {
      return post("/Ecommerce/GetCustomerSupplierQuotationListByPage", data);
    },
    getCustomerSupplierQuotationBySQId(data) {
      return post("/Ecommerce/GetCustomerSupplierQuotationBySQId", data);
    },
    getEntrustOrderList(data) {
      return post("/EntrustOrder/GetEntrustOrderList", data);
    },
    getQuotationReferenceList(data) {
      return post("/EntrustOrder/GetQuotationReferenceList", data);
    },
    addQuotationReference(data) {
      return post("/EntrustOrder/AddQuotationReference", data);
    },
    getQuotationReferenceInfo(data) {
      return post("/EntrustOrder/GetQuotationReferenceInfo", data);
    },
    deleteQuotationReference(data) {
      return post("/EntrustOrder/DeleteQuotationReference", data);
    },
    getEntrustOrderInfo(data) {
      return post("/EntrustOrder/GetEntrustOrderInfo", data);
    },
    getContactListByCompanyName(data) {
      return post("/EntrustOrder/GetContactListByCompanyName", data);
    },
    editGoodsName(data) {
      return post("/EntrustOrder/EditGoodsName", data);
    },
    updateEntrustOrderContactRecord(data) {
      return post("/EntrustOrder/UpdateEntrustOrderContactRecord", data);
    },
    cargoStorageInquiry(data) {
      return post("/Storage/CargoStorageInquiry", data);
    },
    cargoFlowStatement(data) {
      return post("/Storage/CargoFlowStatement", data);
    },
    getStorageEmailConfig(data) {
      return post("/Storage/GetStorageEmailConfig", data);
    },
    saveStorageEmailConfig(data) {
      return post("/Storage/SaveStorageEmailConfig", data);
    },
    testStorageEmailPush(data) {
      return post("/Storage/TestStorageEmailPush", data);
    },
    pushStorageEmailByParam(data) {
      return post("/Storage/PushStorageEmailByParam", data);
    },
    getFinancialReconciliationList(data) {
      return post("/EntrustOrder/GetFinancialReconciliationList", data);
    },
    getFreightBillPayableList(data) {
      return post("/EntrustOrder/GetFreightBillPayableList", data);
    }
  },
  supplier: {
    getSupplierTransportationServiceInfoList(data) {
      return post("/Supplier/GetSupplierTransportationServiceInfoList", data);
    },
    getSupplierAutomobileTransportationServiceInfoList(data) {
      return post("/Supplier/GetSupplierAutomobileTransportationServiceInfoList", data);
    },
    getSupplierWarehousingServiceInfoList(data) {
      return post("/Supplier/GetSupplierWarehousingServiceInfoList", data);
    },
    getSupplierIndustryValueAddedSupportingServiceInfoList(data) {
      return post("/Supplier/GetSupplierIndustryValueAddedSupportingServiceInfoList", data);
    },
    getSupplierQuestionnaireAnswerListBySIRId(data) {
      return post("/Supplier/GetSupplierQuestionnaireAnswerListBySIRId", data);
    },
    getSupplierInfoRecordList(data) {
      return post("/Supplier/GetSupplierInfoRecordList", data);
    },
    getOverseasAgentServiceList(data) {
      return post("/MarketRisk/GetOverseasAgentServiceList", data);
    },
    getOverseasAgentServiceSetting(data) {
      return post("/MarketRisk/GetOverseasAgentServiceSetting", data);
    },
    addOverseasAgentService(data) {
      return post("/MarketRisk/AddOverseasAgentService", data);
    },
    editOverseasAgentService(data) {
      return post("/MarketRisk/EditOverseasAgentService", data);
    },
    getOverseasAgentServiceDetail(data) {
      return post("/MarketRisk/GetOverseasAgentServiceDetail", data);
    },
  },
  businessLogistics: {
    loadEmployeeArchivesInfo(data) {
      return post("/BusinessLogistics/LoadEmployeeArchivesInfo", data);
    },
    saveEmployeeArchivesInfo(data) {
      return post("/BusinessLogistics/SaveEmployeeArchivesInfo", data);
    },
    getAssetCategoryList(data) {
      return post("/BusinessLogistics/GetAssetCategoryList", data);
    },
    getAssetDigitalList(data) {
      return post("/BusinessLogistics/GetAssetDigitalList", data);
    },
    getAssetFixedList(data) {
      return post("/BusinessLogistics/GetAssetFixedList", data);
    },
    getAssetInfo(data) {
      return post("/BusinessLogistics/GetAssetInfo", data);
    },
    addAssetInfo(data) {
      return post("/BusinessLogistics/AddAssetInfo", data);
    },
    editAssetInfo(data) {
      return post("/BusinessLogistics/EditAssetInfo", data);
    },
    deleteAssetInfo(data) {
      return post("/BusinessLogistics/DeleteAssetInfo", data);
    },
    addAssetCategory(data) {
      return post("/BusinessLogistics/AddAssetCategory", data);
    },
    getAssetHandoverRecordsListByAssetId(data) {
      return post("/BusinessLogistics/GetAssetHandoverRecordsListByAssetId", data);
    },
    getEmployeeArchivesList(data) {
      return post("/BusinessLogistics/GetEmployeeArchivesList", data);
    },
    getEmployeeArchivesInfoDetail(data) {
      return post("/BusinessLogistics/GetEmployeeArchivesInfoDetail", data);
    },
    getAssetInfoListByCategory(data) {
      return post("/BusinessLogistics/GetAssetInfoListByCategory", data);
    },
    saveResourceAllocationOperation(data) {
      return post("/BusinessLogistics/SaveResourceAllocationOperation", data);
    },
    employeeResignationOperation(data) {
      return post("/BusinessLogistics/EmployeeResignationOperation", data);
    }
  },
  onlineOrderManagement: {
    getWarehouseInfoList(data) {
      return post("/Ecommerce/GetWarehouseInfoList", data);
    },
    addWarehouseInfo(data) {
      return post("/Ecommerce/AddWarehouseInfo", data);
    },
    deleteWarehouseInfo(data) {
      return post("/Ecommerce/DeleteWarehouseInfo", data);
    },
    loadWarehouseInfo(data) {
      return post("/Ecommerce/LoadWarehouseInfo", data);
    },
    editWarehouseInfo(data) {
      return post("/Ecommerce/EditWarehouseInfo", data);
    },
    editWarehouseState(data) {
      return post("/Ecommerce/EditWarehouseState", data);
    },
    getQuotationInfoList(data) {
      return post("/Ecommerce/GetQuotationInfoList", data);
    },
    editQuotationState(data) {
      return post("/Ecommerce/EditQuotationState", data);
    },
    deleteQuotationInfo(data) {
      return post("/Ecommerce/DeleteQuotationInfo", data);
    },
    loadQuotationInfo(data) {
      return post("/Ecommerce/LoadQuotationInfo", data);
    },
    addQuotationInfo(data) {
      return post("/Ecommerce/AddQuotationInfo", data);
    },
    editQuotationInfo(data) {
      return post("/Ecommerce/EditQuotationInfo", data);
    },
    getVCByCountrysList(data) {
      return post("/Ecommerce/GetVCByCountrysList", data);
    },
    getCustomerOrderAlreadyInStorageCountryListByOrderState(data) {
      return post("/Ecommerce/GetCustomerOrderAlreadyInStorageCountryListByOrderState", data);
    },
    getCustomerOrderPutInStorageListByPage(data) {
      return post("/Ecommerce/GetCustomerOrderPutInStorageListByPage", data);
    },
    editCustomerOrderPutInStorage(data) {
      return post("/Ecommerce/EditCustomerOrderPutInStorage", data);
    },
    getCustomerOrderAlreadyInStorageListByPage(data) {
      return post("/Ecommerce/GetCustomerOrderAlreadyInStorageListByPage", data);
    },
    getCustomerOrderHasShippedListByPage(data) {
      return post("/Ecommerce/GetCustomerOrderHasShippedListByPage", data);
    },
    getCustomerOrderListByWBId(data) {
      return post("/Ecommerce/GetCustomerOrderListByWBId", data);
    },
    getCustomerOrderAlreadyInStorageListByTransportService(data) {
      return post("/Ecommerce/GetCustomerOrderAlreadyInStorageListByTransportService", data);
    },
    addExpressWaybillByCOIdList(data) {
      return post("/Ecommerce/AddExpressWaybillByCOIdList", data);
    },
    getFreightPriceListByPage(data) {
      return post("/Purchasing/GetFreightPriceListByPage", data);
    },
    loadFreightPriceInfo(data) {
      return post("/Purchasing/LoadFreightPriceInfo", data);
    },
    getFreightPriceDetailListByOrderStateAndFPId(data) {
      return post("/Ecommerce/GetFreightPriceDetailListByOrderStateAndFPId", data);
    },
    deleteFreightPrice(data) {
      return post("/Purchasing/DeleteFreightPrice", data);
    },
    addFreightPrice(data) {
      return post("/Purchasing/AddFreightPrice", data);
    },
    editFreightPrice(data) {
      return post("/Purchasing/EditFreightPrice", data);
    },
    deleteCustomerOrder(data) {
      return post("/Purchasing/DeleteCustomerOrder", data);
    },
    addFreightPriceCustomerDiscount(data) {
      return post("/Purchasing/AddFreightPriceCustomerDiscount", data);
    },
    deleteFreightPriceCustomerDiscount(data) {
      return post("/Purchasing/DeleteFreightPriceCustomerDiscount", data);
    },
    getFreightPriceCustomerDiscountListByPage(data) {
      return post("/Purchasing/GetFreightPriceCustomerDiscountListByPage", data);
    },
    getLogisticsChannelMappings(data) {
      return post("/Purchasing/GetLogisticsChannelMappings", data);
    },
    getCustomerBillDetailsByCEId(data) {
      return post("/Purchasing/GetCustomerBillDetailsByCEId", data);
    },
    customerAccountRecharge(data) {
      return post("/Purchasing/CustomerAccountRecharge", data);
    },
    customerCancelRecharge(data) {
      return post("/Purchasing/CustomerCancelRecharge", data);
    },
    loadFreightPriceCustomerDiscountInfo(data) {
      return post("/Purchasing/LoadFreightPriceCustomerDiscountInfo", data);
    },
    batchAddFreightPriceCustomerDiscount(data) {
      return post("/Purchasing/BatchAddFreightPriceCustomerDiscount", data);
    },
    getFreightPricePointsRulesListByFPId(data) {
      return post("/Purchasing/GetFreightPricePointsRulesListByFPId", data);
    },
    addFreightPricePointsRules(data) {
      return post("/Purchasing/AddFreightPricePointsRules", data);
    },
    deleteFreightPricePointsRulesByPRId(data) {
      return post("/Purchasing/DeleteFreightPricePointsRulesByPRId", data);
    },
    getPointsRulesHistoryListByPage(data) {
      return post("/Purchasing/GetPointsRulesHistoryListByPage", data);
    },
    getSupplierQuotationListByPage(data) {
      return post("/Ecommerce/GetSupplierQuotationListByPage", data);
    },
    editSupplierQuotationStateBySQId(data) {
      return post("/Ecommerce/EditSupplierQuotationStateBySQId", data);
    },
    customerOrderUnpack(data) {
      return post("/Ecommerce/CustomerOrderUnpack", data);
    },
    getCurrencyList(data) {
      return post("/Ecommerce/GetCurrencyList", data);
    },
    getQuotationServiceBillingUnitList(data) {
      return post("/Ecommerce/GetQuotationServiceBillingUnitList", data);
    },
    addSupplierQuotation(data) {
      return post("/Ecommerce/AddSupplierQuotation", data);
    },
    getSupplierQuotationBySQId(data) {
      return post("/Ecommerce/GetSupplierQuotationBySQId", data);
    },
    calculateSupplierQuotationCostPrice(data) {
      return post("/Ecommerce/CalculateSupplierQuotationCostPrice", data);
    }
  },
  calculator: {
    freightPriceCalculator(data) {
      return post("/Purchasing/FreightPriceCalculator", data);
    }
  },
  address: {
    addCustomerReceiving(data) {
      return post("/Purchasing/AddCustomerReceiving", data);
    },
    getCustomerReceivingList(data) {
      return post("/Purchasing/GetCustomerReceivingList", data);
    },
    editCustomerReceiving(data) {
      return post("/Purchasing/EditCustomerReceiving", data);
    },
    deleteCustomerReceiving(data) {
      return post("/Purchasing/DeleteCustomerReceiving", data);
    },
  },
  purchasingManagement: {
    addBusinessEntity(data) {
      return post("/System/AddBusinessEntity", data);
    },
    getBusinessEntityListByPage(data) {
      return post("/System/GetBusinessEntityListByPage", data);
    },
    getBusinessEntityInfoByBEId(data) {
      return post("/System/GetBusinessEntityInfoByBEId", data);
    },
    editBusinessEntity(data) {
      return post("/System/EditBusinessEntity", data);
    },
    updateBusinessEntityStatusByBEId(data) {
      return post("/System/UpdateBusinessEntityStatusByBEId", data);
    },
    getProcurementProductListByPage(data) {
      return post("/Procurement/GetProcurementProductListByPage", data);
    },
    deleteProcurementProduct(data) {
      return post("/Procurement/DeleteProcurementProduct", data);
    },
    editProductStateByPId(data) {
      return post("/Procurement/EditProductStateByPId", data);
    },
    getProcurementProductInfoByPId(data) {
      return post("/Procurement/GetProcurementProductInfoByPId", data);
    },
    getProcurementQuotationUnitList(data) {
      return post("/Procurement/GetProcurementQuotationUnitList", data);
    },
    getCustomsDeclarationList(data) {
      return post("/Procurement/GetCustomsDeclarationList", data);
    },
    addProcurementProduct(data) {
      return post("/Procurement/AddProcurementProduct", data);
    },
    editProcurementProduct(data) {
      return post("/Procurement/EditProcurementProduct", data);
    },
    deleteProcurementQuotationUnit(data) {
      return post("/Procurement/DeleteProcurementQuotationUnit", data);
    },
    getProcurementQuotationUnitListByPage(data) {
      return post("/Procurement/GetProcurementQuotationUnitListByPage", data);
    },
    addProcurementQuotationUnit(data) {
      return post("/Procurement/AddProcurementQuotationUnit", data);
    },
    editProcurementQuotationUnit(data) {
      return post("/Procurement/EditProcurementQuotationUnit", data);
    },
    getTradeOrderListByPage(data) {
      return post("/Procurement/GetTradeOrderListByPage", data);
    },
    deleteTradeOrder(data) {
      return post("/Procurement/DeleteTradeOrder", data);
    },
    tradeOrderCustomerAccountReconciliation(data) {
      return post("/Procurement/TradeOrderCustomerAccountReconciliation", data);
    },
    getProcurementProductQuotationListByPage(data) {
      return post("/Procurement/GetProcurementProductQuotationListByPage", data);
    },
    deleteProcurementProductQuotation(data) {
      return post("/Procurement/DeleteProcurementProductQuotation", data);
    },
    getProcurementProductInfoByPId(data) {
      return post("/Procurement/GetProcurementProductInfoByPId", data);
    },
    getProcurementProductQuotationDetailByPQId(data) {
      return post("/Procurement/GetProcurementProductQuotationDetailByPQId", data);
    },
    addProcurementProductQuotation(data) {
      return post("/Procurement/AddProcurementProductQuotation", data);
    },
    editProcurementProductQuotation(data) {
      return post("/Procurement/EditProcurementProductQuotation", data);
    },
    editQuoteStateByPQId(data) {
      return post("/Procurement/EditQuoteStateByPQId", data);
    },
    getTradeOrderByTOId(data) {
      return post("/Procurement/GetTradeOrderByTOId", data);
    },
    getTradeClauseList(data) {
      return post("/Procurement/GetTradeClauseList", data);
    },
    getTradeOrderDraftListByUserId(data) {
      return post("/Procurement/GetTradeOrderDraftListByUserId", data);
    },
    getProcurementProductListByCondition(data) {
      return post("/Procurement/GetProcurementProductListByCondition", data);
    },
    getProcurementProductQuotationListByPId(data) {
      return post("/Procurement/GetProcurementProductQuotationListByPId", data);
    },
    deleteTradeOrderDraft(data) {
      return post("/Procurement/DeleteTradeOrderDraft", data);
    },
    saveTradeOrderDraft(data) {
      return post("/Procurement/SaveTradeOrderDraft", data);
    },
    editTradeOrder(data) {
      return post("/Procurement/EditTradeOrder", data);
    },
    addTradeOrder(data) {
      return post("/Procurement/AddTradeOrder", data);
    },
    getAvailableBusinessEntityList(data) {
      return post("/Procurement/GetAvailableBusinessEntityList", data);
    },
    getBankAccountByCustomerNumber(data) {
      return post("/Procurement/GetBankAccountByCustomerNumber", data);
    },
    getBusinessEntityCollectionAccountListByBEId(data) {
      return post("/Procurement/GetBusinessEntityCollectionAccountListByBEId", data);
    }
  },
  myWallet: {
    getCustomerFundUseDetailAndAvailableFundList(data) {
      return post("/Purchasing/GetCustomerFundUseDetailAndAvailableFundList", data);
    },
    getCustomerPayBillList(data) {
      return post("/Purchasing/GetCustomerPayBillList", data);
    },
    getCustomerPayBillListByNuclearAccountNo(data) {
      return post("/Purchasing/GetCustomerPayBillListByNuclearAccountNo", data);
    },
    getPayBillDetail(data) {
      return post("/Purchasing/GetPayBillDetail", data);
    },
    getCustomerRechargeRecordsListByPage(data) {
      return post("/Purchasing/GetCustomerRechargeRecordsListByPage", data);
    }
  },
  order: {
    paymentCollectionBill(data) {
      return post("/Purchasing/PaymentCollectionBill", data);
    }
  },
  orderManagement: {
    getCustomerLogisticsOrderListByPage(data) {
      return post("/Purchasing/GetCustomerLogisticsOrderListByPage", data);
    },
    createLogisticsOrder(data) {
      return post("/Purchasing/CreateLogisticsOrder", data);
    },
    getCustomerLogisticsOrderByCLOId(data) {
      return post("/Purchasing/GetCustomerLogisticsOrderByCLOId", data);
    }
  }
};

export default api;
